import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { dashboardAPI as apiConfig } from '../../../axiosConfig';

const URL = 'payment-options-proxy?endpoint=paymentdashboard';

export const getCurrencies = createAsyncThunk(
  'currencies',
  async (_, { getState }) => {
    if (getState().paymentOptions.currencies.currencyList.length)
      return { details: getState().paymentOptions.currencies.currencyList };

    const url = `${URL}/currencies`;
    const response = await apiConfig.get(url).catch((error) => {
      console.error(JSON.stringify(error));
      return error && error.response;
    });

    response.data.details.sort((a, b) => a.id - b.id);

    return response.data;
  },
);

const paymentOptionsCurrenciesSlice = createSlice({
  name: 'legacyPaymentOptionsCurrencies',
  initialState: {
    currencyList: [],
  },
  reducers: {
    resetCurrencies(state) {
      state.currencyList = [];
    },
  },
  extraReducers: {
    [getCurrencies.fulfilled]: (state, action) => {
      if (!action.payload || !action.payload.details) {
        state.currencyList = [];
        return;
      }

      state.currencyList = action.payload.details;
    },
  },
});

export const paymentOptionsCurrenciesActions =
  paymentOptionsCurrenciesSlice.actions;

export const selectCurrencies = (state) =>
  state.paymentOptions.currencies.currencyList;

export default paymentOptionsCurrenciesSlice.reducer;
